import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    LocationName: { label: i18n.t('app.name'), value: '' },
    SendType: { label: i18n.t('app.forma_envio'), value: '' },
    Address: { label: i18n.t('address.location'), value: '' },
    CountryCode: { label: i18n.t('address.pais'), value: '' },
    PostCode: { label: i18n.t('address.codigo_postal'), value: '' },
    Province: { label: i18n.t('address.provincia'), value: '' },
    Town: { label: i18n.t('address.poblacion'), value: '' },
    Telephone: { label: i18n.t('address.telefono'), value: '' },
    TeleFax: { label: i18n.t('contacto.TeleFax'), value: '' },
    WebAddress: { label: i18n.t('contacto.WebAddress'), value: '' },
    ElectronicMail: { label: i18n.tc('users.email', 1), value: '' },
    ContactPersons: { label: i18n.t('contacto.entity_name_plural'), value: '' },
    CnoCnae: { label: i18n.t('administrativecenter.cno_cnae'), value: '' },
    INETownCode: { label: i18n.t('administrativecenter.INE_town_code'), value: '' },
    AdditionalDetails: { label: i18n.t('administrativecenter.additional_details'), value: '' },
    DIRE: { label: i18n.t('companies.configuration_rec.dire'), value: '' },
    Name: { label: i18n.t('app.name'), value: '' },
  }
}


const getColumns = function getColumns () {
  return [
    { field: 'LocationName', title: i18n.t('app.name'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'SendType', title: i18n.t('app.forma_envio'), format: '["TIPOS_PGE" , "TIPOS_PGE_RECEPCION"]', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'LocationRoles', title: i18n.tc('app.role', 1), format: 'TIPOS_ROL_AGENDA', cell: 'tagsTemplate', columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'Address.Address', title: i18n.t('address.location'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'Address.CountryCode', title: i18n.t('address.pais'), format: 'PAISES', cell: 'enumTemplate', columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'Address.PostCode', title: i18n.t('address.codigo_postal'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'Address.Province', title: i18n.t('address.provincia'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'Address.Town', title: i18n.t('address.poblacion'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.Telephone', title: i18n.t('address.telefono'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.TeleFax', title: i18n.t('administrativecenter.telefax'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.WebAddress', title: i18n.t('contacto.WebAddress'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.ElectronicMail', title: i18n.tc('users.email', 1), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.ContactPersons', title: i18n.t('contacto.entity_name_plural'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.CnoCnae', title: i18n.t('administrativecenter.cno_cnae'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.INETownCode', title: i18n.t('administrativecenter.INE_town_code'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'ContactDetails.AdditionalDetails', title: i18n.t('administrativecenter.additional_details'), columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'FACeB2BIdentificatives.DIRE', title: i18n.t('companies.configuration_rec.dire'), hidden: true, columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'FACeB2BIdentificatives.Name', title: i18n.t('app.name'), hidden: true, columnMenu: 'myTemplate', width: '200px', locked: false },
    { field: 'IdSede', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', width: '150px', locked: false },
  ]
}

const getDefaultState = () => {
  return {
    notificationsNumber: {},
  }
}
const customState = getDefaultState()
const customGetters = {
  getNotificationsNumber: state => state.notificationsNumber,
}
const customMutations = {
  setNotificationsNumber (state, notificationsNumber) {
    state.notificationsNumber = notificationsNumber
  },
  resetNotificationsNumber (state) {
    state.notificationsNumber = {}
  },
}

const mystore = parent({ customState, customGetters, customMutations, selectable: true, navigate: true, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
